import React from 'react';
import { Stack, styled } from '@mui/material';

function MobStepper({ activeStep, steps, onStepClick }) {
  return (
    <StepsContainer>
      {Array.from(Array(steps).keys()).map(step => (
        <Step key={step} onClick={() => onStepClick(step)} active={activeStep === step} />
      ))}
    </StepsContainer>)
  };

const StepsContainer = styled('div')(({ theme }) => ({
  backgroundColor: 'transparent',
  justifyContent: 'center',
  display: 'flex',
  marginTop: theme.spacing(3),
  flexDirection: 'row',
}));

const Step = styled('div')(({ theme, active }) => ({
  width: '11px',
  height: '11.25px',
  margin: '0px 2px',
  borderRadius: '100%',
  backgroundColor: active ? theme.palette.primary.main : theme.palette.grey[400],
  cursor: 'pointer',
}));

export default MobStepper;
